import CallHistoryComponent from './CallHistory.component';

export * from './CallHistory.component';
export default CallHistoryComponent;
